import backgrounds from '../objects/backgrounds';

const ChooseBackground = (x = '0') => {
  const array = backgrounds?.values;

  console.log('background', array);
  return array?.filter((bg) => bg.id == x)?.[0];
};

export default ChooseBackground;
